import Stack from '@mui/material/Stack'
import { FILTERS_MODE } from 'pages/DataAnalysis/components/DataAnalysisFilters/DataAnalysisFilters'
import ColoredAutoSelect from '../ColoredAutoSelect/ColoredAutoSelect'
import ColoredList, { SHAPES } from '../ColoredList/ColoredList'

export type TValues = {
  id: number
  name: string
  color: string
  checked: boolean
}

interface IColoredMultySelect {
  valuesList: TValues[]
  isSquare?: boolean
  mode: FILTERS_MODE
  handleListChange: (nextSelectedNames: string[]) => void
}

const ColoredMultySelect = ({
  valuesList,
  isSquare,
  mode,
  handleListChange,
}: IColoredMultySelect) => {
  const handleToggle = (id: number, checked: boolean) => {
    const next = valuesList.map((it) =>
      it.id === id ? { ...it, checked } : it
    )
    handleListChange(next.filter((i) => i.checked).map((i) => i.name))
  }

  return (
    <Stack>
      {mode === FILTERS_MODE.AUTOCOMPLETE ? (
        <ColoredAutoSelect
          valuesList={valuesList}
          isSquare={isSquare}
          onChangeSelected={(names) => handleListChange(names)}
        />
      ) : (
        <ColoredList
          valuesList={valuesList}
          shape={isSquare ? SHAPES.SQUARE : SHAPES.CIRCLE}
          title=""
          withCheckbox
          onToggle={handleToggle}
        />
      )}
    </Stack>
  )
}

export default ColoredMultySelect
